import React from "react";
import Header from "./Header/Header"; 
import Footer from "./Footer/footer"; 
import ".//PrivacyPolicy/PrivacyPolicy.css";
const TheBlackPrint = () => {
  return (
    <>
      <Header />
      <div className="privacy-container">
        <h1 className="privacy-title">The BlackPrint</h1>
        <div className="privacy-content">
          <p>
Project Black is the home base for Black media, business, and culture, all in one place. It’s
where ideas, resources, and people come together to build something bigger than ourselves.
Think of it as the hub that connects us all: the great minds, the bold thinkers, and the everyday
doers who make the culture move. No more being scattered across platforms. Here, we’re
linked together and building something we own.<br /><br />
<b>Our Vision</b><br /> 
We’re here to make sure Black voices, businesses, and creativity are not just seen but
supported and sustained. Project Black puts the tools, connections, and opportunities in our
hands through The Black Book directory, Project Black University, exclusive drops, media, and
financial tools. Every part of the platform works to keep the Black dollar in our community, share
our stories, and give us all a space to grow together.<br /><br />
<b>The Revolution is Premium™ | Why It Matters</b><br /> 
We are done asking for a seat at someone else’s table. We’re building our own and making sure
it lasts for generations. Project Black is more than a website or a brand. It’s a movement to
make sure Black brilliance is recognized, celebrated, and unstoppable. This is our blueprint.<br/>
This is our time. This is Project Black.<br />

</p>
                 </div>
      </div>
      <Footer />
    </>
  );
};

export default TheBlackPrint;
